import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "./auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TableNumberService} from "../http/table-number.service";

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const _snackBar = inject(MatSnackBar);

  if (authService.isLoggedIn()) {
    const requiredRole = route.data['role'] as string;
    const userRole: string[] = authService.getUserRole();
    if (userRole?.includes(requiredRole)) {
      return true;
    } else {
      // router.navigate(['/login']).then(r => {});
      _snackBar.open('Zu geringe Berechtigungen für diese Aktion', 'Schließen', {duration: 3000});
      return false;
    }
    return true;
  } else {
    router.navigate(['/login']).then(r => {});
    console.error('wrong auth code');
    _snackBar.open('Falscher Login-Code', 'Schließen', {duration: 3000});
    return false;
  }


};
